import { environment as env } from "../../../../../environments/environment";

const SMS_BASE_URL = env.ApiUrl + "v1/"; //
const REPORTING_URL = env.ApiUrl + "api"; // env.ReportingUrl;

export const SMS_ENDPOINTS = {
    list: SMS_BASE_URL + "sms_schedule/list",
    item: SMS_BASE_URL + "sms_schedule/{id}",
    base: SMS_BASE_URL + "instant_sendsms",
    programado: SMS_BASE_URL + "sms_schedule",
    upload: SMS_BASE_URL + "uploadfile/instantsms/",
    template: SMS_BASE_URL + "sms-template",
    // activation: SMS_BASE_URL + '/{id}/activationToggle',
    idNames: REPORTING_URL + "/organization/{id}/operator",
    // itemIdNames: SMS_BASE_URL + '/{id}/items/idNames'
    getReportingData: REPORTING_URL + "/reporting/campaign/{id}",
    getBaseList: REPORTING_URL + "/reporting/campaign/{id}/baselist",
    blacklist: REPORTING_URL + "/blacklist/{id}/list",
    upload_blackList: REPORTING_URL + "/blacklist/uploadfile",
};
